
import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import swal from "sweetalert2";

import * as api from "../constant/NewAPI";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const Schedules = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [newInstituteId, setNewInstituteId] = useState(null);
    const [instituteId, setInstituteId] = useState(null);
    const [batchId, setBatchId] = useState(null);
    const [institutionList, setInstitutionList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [schduleList, setScheduleList] = useState([]);
    const [scheduleId, setScheduleId] = useState(null);
    const [scheduleEditId, setScheduleEditId] = useState(null);
    const [scheduleDate, setScheduleDate] = useState([]);
    const [listScheduleTypes, setListScheduleTypes] = useState([]);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [comments, setComments] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dropdowns, setDropdowns] = useState([]);
    const [previousScheduleDate, setPreviousScheduleDate] = useState(null);
    const [currentDate, setCurrentDate] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [orderedSkills, setOrderedSkills] = useState([]);
    const [previousSkill, setPreviousSkill] = useState(null);
    const [bchPlaceHolder, setBchPlaceHolder] = useState("Please Wait...");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const formRef = useRef(null);
    const cntr = useRef(0);
    const prevDate = useRef('');



    useEffect(() => {
        institList();
        scdlList();
    }, [])

    function institList() {
        const listInstitutions = api.InstDd + '/' + roleId; //'/?userId=' + userId + '&roleId=' + roleId;
        fetch(listInstitutions, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((insResult) => {
                if (insResult.error == false) {
                    setInstitutionList(insResult.data)
                }
                else {
                    swal.fire(insResult.message)
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Error fetching Institute List.", error)
            })
    }

    function scdlList() {
        const listSchedules = api.ScheduleTypes;
        fetch(listSchedules, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((schResponse) => schResponse.json())
            .then((schResult) => {
                if (schResult.error == false) {
                    setListScheduleTypes(schResult.data)
                }
                else {
                    swal.fire(schResult.message)
                    if (schResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Error fetching Schedule Types.", error)
            })
    }

    function listBatch(insId) {
        const instId = insId;
        const fetchBatches = api.ListBatches + '/' + roleId + '/' + instId;// "/?coachId=" + userId + "&insId=" + instId + "&roleId=" + roleId;
        fetch(fetchBatches, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((bchResponse) => bchResponse.json())
            .then((bchResult) => {
                if (bchResult.error == false) {
                    setBatchList(bchResult.data);
                    setBchPlaceHolder("Select a Batch");
                }
                else {
                    swal.fire(bchResult.message)
                    if (bchResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Error fetching Batch List", error);
            })
    }

    function showSchedules() {
        const scdles = api.listSchedules + '/' + roleId + '/' + batchId + '/' + fromDate + '/' + toDate + '/' + instituteId;//"?insId=" + instituteId + "&batchId=" + batchId + "&userId=" + userId + "&roleId=" + roleId + "&dateFrom=" + fromDate + "&dateTo=" + toDate;
        fetch(scdles, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((scdlResponse) => scdlResponse.json())
            .then((scdlResult) => {
                if (scdlResult.error == false) {
                    setScheduleList(scdlResult.data)
                    setShowTable(true)
                }
                else {
                    swal.fire(scdlResult.message)
                    if (scdlResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Error fetching Schedule List", error)
            })
    }

    function archiveBatch(row) {
        const instId = row.batchInstitution;
        const scdlId = row.scheduleId;
        const archivebtch = api.archiveSchedule + '/' + scdlId + '/' + instId; //"/?insId=" + instId + "&scheduleId=" + scdlId;
        fetch(archivebtch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((arcresponse) => arcresponse.json())
            .then((result) => {
                if (result.error == false) {
                    swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to archive batch", error)
            })
    }

    const filteredData = schduleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const addDropdown = (date, batchIdParam = batchId, instituteIdParam = newInstituteId, skillId = null) => {
        const getSkillSet = api.ListSkillSet + '/' + roleId + '/' + batchIdParam + '/' + instituteIdParam;

        // const getSkillSet = api.ListSkillSet + '/' + roleId + '/' + batchId + '/' + newInstituteId;
        // "?coachId=" + userId + "&batchId=" + batchId + "&roleId=" + roleId + "&insId=" + newInstituteId;
        fetch(getSkillSet, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sklResponse) => sklResponse.json())
            .then((sklResult) => {
                if (sklResult.error == true) {
                    swal.fire(sklResult.message)
                }
                else {
                    if (sklResult.data) {
                        const newOptions = sklResult.data.map((item, index) => ({
                            value: item.skillId, // Assuming your API returns 'value' field
                            label: item.skillName, // Assuming your API returns 'text' field
                        }));
                        // console.log('New Options:- ', newOptions)
                        const id = dropdowns.length + new Date().getTime();
                        setDropdowns([
                            ...dropdowns,
                            {
                                id: dropdowns.length + new Date().getTime(),
                                date: date, // Store the date associated with this dropdown
                                options: newOptions,
                            },
                        ]);
                        // Set the selected option using scheduleSkillId
                        setSelectedOptions({
                            [id]: skillId
                        });

                        setScheduleDate([date]);
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to get skill list', error);
            })
    };

    const handleDateChange = (e) => {
        const newDate = e.target.value;
        if (newDate) {
            setSelectedDates(prevDates => {
                if (prevDates.length > 0) {
                    setPreviousScheduleDate(prevDates[prevDates.length - 1]);
                    addDropdown(prevDates[prevDates.length - 1]); // Add a dropdown with the previous date
                }

                if (scheduleId != 3) {
                    const updatedDates = [...prevDates, newDate];
                    addDropdown(newDate); // Add a dropdown with the new date
                    return updatedDates;
                }
            });
            setCurrentDate(newDate);
        }
    };

    // const handleSelectedSkill = (dropdownId) => (selectedOption) => {
    //     if (selectedOption) {
    //         setSelectedOptions((prevValues) => {
    //             const prevSkill = prevValues[dropdownId];
    //             const updatedValues = {
    //                 ...prevValues,
    //                 [dropdownId]: selectedOption.value,
    //             };

    //             // Build new ordered list
    //             const seen = new Set();
    //             const newOrdered = [];

    //             orderedSkills.forEach((skill) => {
    //                 if (Object.values(updatedValues).includes(skill) && !seen.has(skill)) {
    //                     newOrdered.push(skill);
    //                     seen.add(skill);
    //                 }
    //             });

    //             Object.values(updatedValues).forEach((skill) => {
    //                 if (!seen.has(skill)) {
    //                     newOrdered.push(skill);
    //                     seen.add(skill);
    //                 }
    //             });

    //             // Reverse map: skill -> dropdownId (based on updatedValues)
    //             const skillToDropdownMap = {};
    //             for (const [key, value] of Object.entries(updatedValues)) {
    //                 skillToDropdownMap[value] = key;
    //             }

    //             // Rebuild selectedOptions using newOrdered and correct dropdownIds
    //             const rebuiltSelectedOptions = {};
    //             newOrdered.forEach((skill) => {
    //                 const id = skillToDropdownMap[skill];
    //                 if (id) rebuiltSelectedOptions[id] = skill;
    //             });

    //             setOrderedSkills(newOrdered);

    //             if (newOrdered.length > 1) {
    //                 setPreviousSkill(newOrdered[newOrdered.length - 2]);
    //             }

    //             return rebuiltSelectedOptions;
    //         });
    //     }
    // };

    const handleSelectedSkill = (dropdownId) => (selectedOption) => {
        if (selectedOption) {
            setSelectedOptions((prevValues) => {
                const prevSkill = prevValues[dropdownId];
                const updatedValues = {
                    ...prevValues,
                    [dropdownId]: selectedOption.value,
                };

                // Step 1: Keep existing order as much as possible (duplicates allowed)
                const newOrdered = [];
                orderedSkills.forEach((skill) => {
                    if (Object.values(updatedValues).includes(skill)) {
                        newOrdered.push(skill); // No Set check — duplicates allowed
                    }
                });

                // Step 2: Append any newly selected skills (still allowing duplicates)
                Object.values(updatedValues).forEach((skill) => {
                    if (!newOrdered.includes(skill) ||
                        newOrdered.filter(s => s === skill).length <
                        Object.values(updatedValues).filter(s => s === skill).length) {
                        newOrdered.push(skill);
                    }
                });

                // Reverse map: skill -> dropdownId (based on updatedValues)
                const skillToDropdownMap = {};
                for (const [key, value] of Object.entries(updatedValues)) {
                    // Store multiple IDs for the same skill
                    if (!skillToDropdownMap[value]) {
                        skillToDropdownMap[value] = [];
                    }
                    skillToDropdownMap[value].push(key);
                }

                // Rebuild selectedOptions (duplicates allowed)
                const rebuiltSelectedOptions = {};
                const usedIds = new Set();
                newOrdered.forEach((skill) => {
                    const ids = skillToDropdownMap[skill] || [];
                    const nextId = ids.find(id => !usedIds.has(id));
                    if (nextId) {
                        rebuiltSelectedOptions[nextId] = skill;
                        usedIds.add(nextId);
                    }
                });

                setOrderedSkills(newOrdered);

                if (newOrdered.length > 1) {
                    setPreviousSkill(newOrdered[newOrdered.length - 2]);
                }

                return rebuiltSelectedOptions;
            });
        }
    };


    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const convertTo12Hour = (time24: string) => {
        if (!time24) return "";

        const [hour, minute] = time24.split(":");
        let h = parseInt(hour, 10);
        const ampm = h >= 12 ? "PM" : "AM";

        h = h % 12;
        h = h ? h : 12; // 0 becomes 12

        return `${h.toString().padStart(2, "0")}:${minute} ${ampm}`;
    };

    const removeDropdown = (id) => {
        // Find the dropdown to remove from the current state
        const dropdownToRemove = dropdowns.find((dropdown) => dropdown.id === id);
        if (!dropdownToRemove) return;

        // Remove it from dropdown list
        setDropdowns((prevDropdowns) => prevDropdowns.filter((dropdown) => dropdown.id !== id));

        // Remove corresponding date
        setSelectedDates((prevDates) =>
            prevDates.filter((date) => date !== dropdownToRemove.date)
        );
    };

    const clearAllDates = () => {
        setDropdowns([]);
        setScheduleDate([]);
        setSelectedDates([]);
        setSelectedOptions([]);
    }

    function batchSet(e) {
        setBatchId(e.value)
    }
    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData) => {
        return <span>{rowData.batchName}</span>;
    };

    const skillRender = (rowData) => {
        return <span>{rowData.skillName}</span>;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>;
    };

    const startTimeRender = (rowData) => {
        return <span>{rowData.scheduleStartTime}</span>;
    };

    const endTimeRender = (rowData) => {
        return <span>{rowData.scheduleEndTime}</span>;
    };

    const editDetails = (rowData) => {
        if (rowData.scheduleStatus == 1) {
            return (
                <Link to="#" onClick={() => editSchedule(rowData)}>
                    <i className="feather-edit" />
                    Edit
                </Link>
            );
        }
    };

    const archiveRow = (rowData) => {
        return (
            (rowData.scheduleStatus == 1 ?
                <Link to="#" data-bs-toggle="" data-bs-target="" onClick={() => archiveBatch(rowData)} className="dropdown-item">
                    <i className="feather-archive" />
                    Archive
                </Link>
                : null)
        );
    };

    function saveSchedule(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSchedule()
            } else {
                setIsLoading(true)
                setTimeout(() => {
                    const selectedValues = Object.values(selectedOptions);
                    const selectedDateValues = Object.values(selectedDates);
                    const formData = new FormData();
                    formData.append("scheduleInstitution", newInstituteId);
                    formData.append("scheduleSkill", JSON.stringify(selectedValues));
                    formData.append("scheduleBatch", batchId);
                    formData.append("scheduleType", scheduleId);
                    formData.append("scheduleBatchDate", JSON.stringify(selectedDateValues));
                    formData.append("scheduleStartTime", (convertTo12Hour(startTime)));
                    formData.append("scheduleEndTime", (convertTo12Hour(endTime)));
                    formData.append("scheduleComments", comments);

                    //     formData.forEach((value, key) => {
                    //     console.log(`${key}: ${value}`);
                    // });

                    const createSchedule = api.CreateSchedule;
                    fetch(createSchedule, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((scdlResponse) => scdlResponse.json())
                        .then((result) => {
                            setIsLoading(false);
                            if (result.error == false) {
                                swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                        .catch((error) => {
                            console.log("Failed to create new Schedule", error)
                        })
                }, 1000)

            }
        }
    }

    function newSchedule() {
        setNewInstituteId(null)
        setBatchId(null)
        setScheduleId(null)
        setCurrentDate('')
        setStartTime('')
        setEndTime('')

        // Clear previous dropdowns
        setDropdowns([]);
        setSelectedOptions([]);
        setScheduleDate([]);
        setSelectedDates([]);

        setOpenModal(true)
        setIsEdit(false)
    }

    function editSchedule(selectedRow) {

        if (prevDate.current != selectedRow.scheduleDate) {
            // Clear previous dropdowns
            setDropdowns([]);
            setSelectedOptions([]);
            setScheduleDate([]);
            setSelectedDates([])
            cntr.current = 0;

        }
        cntr.current += 1;

        setScheduleEditId(selectedRow.scheduleId)
        setNewInstituteId(selectedRow.batchInstitution)
        setBatchId(selectedRow.scheduleBatchId)
        setScheduleId(selectedRow.scheduleTypeId)
        setCurrentDate(selectedRow.scheduleDate)
        setStartTime(selectedRow.scheduleStartTime)
        setEndTime(selectedRow.scheduleEndTime)


        // Call addDropdown directly with params from selectedRow
        if (cntr.current === 1) {
            prevDate.current = selectedRow.scheduleDate;

            addDropdown(selectedRow.scheduleDate, selectedRow.scheduleBatchId, selectedRow.batchInstitution, selectedRow.scheduleSkillId);
        }
        setIsEdit(true)
        setOpenModal(true)
    }

    function updateSchedule() {
        const selectedValues = Object.values(selectedOptions);
        const selectedSkill = selectedValues.length > 0 ? selectedValues[0] : "";
        const dates = scheduleDate.length > 0 ? scheduleDate[0] : "";

        setIsLoading(true)
        setTimeout(() => {
            const formData = new FormData();
            formData.append("scheduleId", scheduleEditId);
            formData.append("scheduleInstitution", newInstituteId);
            formData.append("scheduleSkill", selectedSkill);
            formData.append("scheduleBatch", batchId);
            formData.append("scheduleType", scheduleId);
            formData.append("scheduleBatchDate", dates);
            formData.append("scheduleStartTime", startTime);
            formData.append("scheduleEndTime", endTime);
            formData.append("scheduleComments", comments);

            // formData.forEach((value, key) => {
            //     console.log(`${key}: ${value}`);
            // });

            const scheduleUpdate = api.ScheduleUpdate;
            fetch(scheduleUpdate, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((scdlResponse) => scdlResponse.json())
                .then((result) => {
                    setIsLoading(false);
                    if (result.error == false) {
                        swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log("Failed to update Schedule", error)
                })
        }, 1000)
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h4 className="text-center mb-40">Schedules</h4>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12">
                                                            <div className="row col-md-12">

                                                                {(roleId == '1' || roleId == '6') && (
                                                                    <>
                                                                        <div className="col-md-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-secondary"
                                                                                // data-bs-toggle="modal"
                                                                                // data-bs-target="#create-schedule"
                                                                                onClick={() => newSchedule()}>

                                                                                <i className="feather-plus" />&nbsp;
                                                                                Create New Schedule
                                                                            </Link>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="col-md-12"></div>
                                                            <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                            <div className="row col-md-12 court-sortby sortbyset">
                                                                <div className="col-md-3">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select
                                                                            value={institutionList.find(ins => ins.institutionId === instituteId) ? {
                                                                                value: instituteId,
                                                                                label: institutionList.find(ins => ins.institutionId === instituteId).institutionName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setInstituteId(e.value);
                                                                                listBatch(e.value)
                                                                            }}
                                                                            options={institutionList.map(ins => ({
                                                                                value: ins.institutionId,
                                                                                label: ins.institutionName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>Batch</h6></label>
                                                                        <Select value={batchList.find(bch => bch.batchId === batchId) ? {
                                                                            value: batchId,
                                                                            label: batchList.find(bch => bch.batchId === batchId).batchName
                                                                        } : null}
                                                                            onChange={batchSet}
                                                                            options={batchList.map(bch => ({
                                                                                value: bch.batchId,
                                                                                label: bch.batchName
                                                                            }))}
                                                                            placeholder={bchPlaceHolder}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="table-accept-btn" style={{ marginTop: "1.8rem" }}>
                                                                        <Link to="#" className="btn btn-primary close" style={{ padding: "7px 60px" }} onClick={showSchedules}>
                                                                            <i className="feather-eye"></i>Show
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {showTable && (
                                                            <>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-12">
                                                                </div>
                                                                <div className="col-md-6">
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchInput}
                                                                                onChange={(e) => setSearchInput(e.target.value)}
                                                                                placeholder="Search"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {showTable && (
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                    pageLinkSize={3}
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="slNo"
                                                                        body={slNoRender}
                                                                        header="Sl No"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="batchName"
                                                                        header="Batch"
                                                                        className="table-inset-btn"
                                                                        body={batchRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="skillName"
                                                                        header="Skill"
                                                                        className="table-inset-btn"
                                                                        body={skillRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="scheduleDate"
                                                                        header="Date"
                                                                        className="table-inset-btn"
                                                                        body={dateRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="scheduleStartTime"
                                                                        header="Start Time"
                                                                        body={startTimeRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="scheduleEndTime"
                                                                        header="End Time"
                                                                        body={endTimeRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="details"
                                                                        header="Details"
                                                                    ></Column>
                                                                    {(roleId == '1' || roleId == '6') && (
                                                                        <>
                                                                            <Column
                                                                                body={archiveRow}
                                                                            ></Column>
                                                                            <Column
                                                                                body={editDetails}
                                                                            ></Column>
                                                                        </>
                                                                    )}
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Show Schedule List */}
            {/* /Show Schedule List */}

            {/* Create New Schedule Modal */}

            <Modal
                show={openModal}
                size="xl"
                centered
                onHide={() => setOpenModal(false)}
                backdrop="static"       // disables closing on outside click
                keyboard={false}        // disables closing on Esc key
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Create "}Schedule</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => { setOpenModal(false); window.location.reload() }}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row col-md-12">
                            <div className="col-md-6">
                                <div className="card-title text-center">
                                    Details
                                </div>
                                <div className="col-md-12 mb-10">
                                    <label className="sortbytitle"><h6>Institute</h6></label>
                                    <Select
                                        value={institutionList.find(ins => ins.institutionId === newInstituteId) ? {
                                            value: newInstituteId,
                                            label: institutionList.find(ins => ins.institutionId === newInstituteId).institutionName
                                        } : null}
                                        onChange={(e) => {
                                            setNewInstituteId(e.value);
                                            listBatch(e.value)
                                        }}
                                        required
                                        isDisabled={isEdit}
                                        options={institutionList.map(ins => ({
                                            value: ins.institutionId,
                                            label: ins.institutionName
                                        }))}>
                                    </Select>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Batch</h6></label>
                                        <Select value={batchList.find(bch => bch.batchId === batchId) ? {
                                            value: batchId,
                                            label: batchList.find(bch => bch.batchId === batchId).batchName
                                        } : null}
                                            onChange={(e) => {
                                                setBatchId(e.value);
                                            }}
                                            required
                                            options={batchList.map(bch => ({
                                                value: bch.batchId,
                                                label: bch.batchName
                                            }))}
                                            placeholder={bchPlaceHolder}
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-10">
                                        <label className="sortbytitle"><h6>Schedule Type</h6></label>
                                        <Select
                                            value={listScheduleTypes.find(sch => sch.schedulesId === scheduleId) ? {
                                                value: scheduleId,
                                                label: listScheduleTypes.find(sch => sch.schedulesId === scheduleId).schedulesName
                                            } : null}
                                            onChange={(e) => {
                                                setScheduleId(e.value);
                                            }}
                                            required
                                            options={listScheduleTypes.map(sch => ({
                                                value: sch.schedulesId,
                                                label: sch.schedulesName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>

                                <div className="mb-10">
                                    <label className="sortbytitle"><h6>Schedule Date</h6></label>
                                    <input type="date" className="col-md-12" required disabled={isEdit} style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={currentDate} onChange={handleDateChange}></input>
                                </div>

                                <div className="row">
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Start Time</h6></label>
                                        <input type="time" className="col-lg-12" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                                    </div>
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>End Time</h6></label>
                                        <input type="time" className="col-lg-12" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                                    </div>
                                </div>

                                <div className="mb-10">
                                    <label className="sortbytitle"><h6>Comments</h6></label>
                                    <textarea className="col-md-12" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={comments} onChange={(e) => setComments(e.target.value)} />
                                </div>
                                {/* </div> */}
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card-title">
                                            Select Skills For Dates
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <a href="#" onClick={clearAllDates}><span>X</span><u>Clear all Data</u></a>
                                    </div>
                                </div>
                                {dropdowns.map((dropdown) => (
                                    <div className="mb-10" key={dropdown.id}>
                                        <div className="info d-lg-flex justify-content-between">
                                            <label className="sortbytitle"><h6>{formatDate(dropdown.date)}</h6></label>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                removeDropdown(dropdown.id);
                                            }}><span>X</span><u>Remove</u></a>
                                        </div>
                                        <Select
                                            key={dropdown.id}
                                            // value={selectedOptions[dropdown.id] || null}
                                            value={dropdown.options.find(option => option.value === selectedOptions[dropdown.id]) || null}
                                            options={dropdown.options}
                                            required
                                            onChange={handleSelectedSkill(dropdown.id)}
                                            className="dropdown" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={saveSchedule}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal >
            {/* /Create New Schedule Modal */}
        </>
    )
};

export default Schedules;